import { AccountingLineRpt } from 'types';
import { GroupedData, TempAccounts, AccountTotals, AccountingLineDisplay, GroupingResult } from './types';

export const calculateTotals = (groupedByAccount: GroupedData): Record<string, AccountTotals> => {
  const totals: { [key: string]: AccountTotals } = {};
  Object.entries(groupedByAccount).forEach(([org, data]) => {
    totals[org] = {};
    data.forEach((row) => {
      const account = row.acctCtx_s3;
      const debit = row.acctDebit || 0;
      const credit = row.acctCredit || 0;

      if (!account) return;
      if (!totals[org][account]) {
        totals[org][account] = { debit: 0, credit: 0 };
      }
      totals[org][account].debit += debit;
      totals[org][account].credit += credit;
    });
  });
  return totals;
};

export const FILTERED_COLUMNS = ['agmtCtx_name', 'mappingCtx_name', 'transType'];
const ALL_COLUMNS = ['acctDebit', 'acctCredit', 'acctCtx_s3', 'acctCtx_s1', ...FILTERED_COLUMNS];

export const extractTAccountData = (row: AccountingLineDisplay, rowIndex: number): AccountingLineDisplay => {
  const result: AccountingLineDisplay = {
    _rowId: `${row.acctCtx_s1}-${row.acctCtx_s3}-${rowIndex}`,
    acctCtx_s3: null,
    acctCtx_s1: null,
    acctDebit: null,
    acctCredit: null,
  };
  ALL_COLUMNS.forEach((col) => {
    const value = row[col as keyof AccountingLineRpt];
    result[col] = typeof value === 'string' || typeof value === 'number' ? value : null;
  });
  return result;
};

export const groupRowsByAccount = (rows: object[]): GroupingResult => {
  const typedRows = rows as AccountingLineDisplay[];
  const tempAccounts: TempAccounts = {};
  const groupedByAccount: GroupedData = {};

  typedRows.forEach((row, index) => {
    const tAccountData = extractTAccountData(row, index);
    const acctCtx_s3 = tAccountData.acctCtx_s3;
    const acctCtx_s1 = tAccountData.acctCtx_s1;

    if (!acctCtx_s1 || !acctCtx_s3) return;

    if (!tempAccounts[acctCtx_s1]) {
      tempAccounts[acctCtx_s1] = [];
    }
    if (!tempAccounts[acctCtx_s1].includes(acctCtx_s3)) {
      tempAccounts[acctCtx_s1].push(acctCtx_s3);
    }

    if (!groupedByAccount[acctCtx_s1]) {
      groupedByAccount[acctCtx_s1] = [];
    }
    groupedByAccount[acctCtx_s1].push(tAccountData);
  });

  return { tempAccounts, groupedByAccount };
};

export const padAccountsToSameLength = (tempAccounts: TempAccounts): void => {
  const maxLength = Math.max(...Object.values(tempAccounts).map((arr) => arr.length), 0);
  Object.keys(tempAccounts).forEach((key) => {
    while (tempAccounts[key].length < maxLength) {
      tempAccounts[key].push('');
    }
  });
};
